<template>
  <div>
    <b-card>

      <Breadcrumb title="Inventario - Editar sección" link="/inventory/sections" />

      <FormCreateSection action="UPDATE" :dangers="casDangers" @on-btn-ok="onHandleBtnOK" />     

    </b-card>
  </div>
</template>

<script>

// Componentes
import Breadcrumb from '../components/Breadcrumb.vue'
import FormCreateSection from '../components/sections/Form.vue'

// Mixins
import FormMixin from "../../../servicios/inventory/mixins/sections/form"

export default {

  name: 'InventorySectionsUpdate',

  components: {
    Breadcrumb,
    FormCreateSection
  },

  mixins: [FormMixin],

};
</script>
